export const serverURI = 'https://www.utech.com.my:5888';
export const firebaseConfig = {
  apiKey: "AIzaSyDTluAF5RlnC4srDwJWVOn2_K3zUi-tbiQ",
  authDomain: "utech-e9545.firebaseapp.com",
  databaseURL: "https://utech-e9545.firebaseio.com",
  projectId: "utech-e9545",
  storageBucket: "utech-e9545.appspot.com",
  messagingSenderId: "1047102441749"
};
